import VueCookies from 'vue-cookies'
import {Message} from 'view-design';
var _this = this;
// setToken
export const setCookies = (key, val, cookieExpires) => {
    VueCookies.set(key, val, { expires: cookieExpires || 1 })
}

// 获取getCookies
export const getCookies = (key) => {
    return VueCookies.get(key)
}

export const removeCookies = (key) => {
    return VueCookies.remove(key)
}

export const copyText = (val) => {
    let input = document.createElement("input");
    input.value = val;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy")
    document.body.removeChild(input);
    Message.success("复制成功")
}

export const getNgumgberOfDays = (date1,date2) => {//获得天数
    //date1：开始日期，date2结束日期
    var a1 = Date.parse(new Date(date1));
    var a2 = Date.parse(new Date(date2));
    if (a1  > a2) {return 0}

    var day = parseInt((a2-a1)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
    return day
};
export const getCurrentDate = () => {//获得天数
    var date = new Date();
    var year = date.getFullYear(),month = date.getMonth() + 1, day = date.getDate();
    month = (month > 9) ? month : ("0" + month);
    var h = date.getHours(),   m = date.getMinutes(),  s = date.getSeconds();
    day = (day < 10) ? ("0" + day) : day;
    return  year + "-" + month + "-" + day + " " + h+":"+m+":"+s;
};
